import CableReady from 'cable_ready'
import consumer from "./consumer"

document.addEventListener("exportations:redirect", ({ detail }) => {
  const url = detail?.url

  if (url) {
    window.location.assign(url)
  }
})

document.addEventListener("importations:updated", () => {
  if (window.location.pathname.startsWith("/importations")) {
    if (window.Turbo) {
      window.Turbo.visit(window.location.href, { action: "replace" })
    } else {
      window.location.reload()
    }
  }
})

consumer.subscriptions.create("UserChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    if (data.cableReady) CableReady.perform(data.operations)
  }
});
